function slug() {
  return devMode ? `?${Date.now()}` : '';
}
export default {
  install(Vue, { CDN }) {
    Vue.prototype.$cdn = {
      ...CDN,
      resource(filepath) {
        return `${CDN.baseUrl}/assets/resources/${filepath}${slug()}`;
      }
    };
  }
};
